import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../../../../../components/pagination";
import TableRowCount from "../../../../../components/pagination/rows";
import {
  SetActivePAGE,
  SetMaxPage,
} from "../../../../../services/redux/slices/market/machines";

export default function MachineFooter() {
  const dispatch = useDispatch();
  const { maxPage } = useSelector(({ auth }) => auth);
  const { isLoading, totalPages, activePage } = useSelector(
    ({ machines }) => machines
  );

  useEffect(() => {
    dispatch(SetMaxPage(maxPage));
  }, [dispatch, maxPage]);

  const handlePageChange = (action) => {
    const nextPage =
      typeof action === "number" ? action : activePage + (action ? 1 : -1);

    if (nextPage >= 1 && nextPage <= totalPages) {
      dispatch(SetActivePAGE(nextPage));
    }
  };

  return (
    <div className="mb-auto d-flex justify-content-between align-items-center px-4">
      <TableRowCount disablePageSelect={false} />
      <Pagination
        isLoading={isLoading}
        total={totalPages}
        page={activePage}
        setPage={handlePageChange}
      />
    </div>
  );
}
